import React, { useRef, useEffect, useCallback, useState} from 'react';
import ZCanvas3DComponent from "components/zobject/custom/ZCanvas3DComponent.js";
import EmptySlot from './EmptySlot.js';
import {GO_TO_PAD_SEQUENCER} from 'constants/contextual-help.js';
import {useDoubleClick} from "components/hooks/useDoubleClick.js";
import {
    setShowPadSequencer,
    setSelectedZObject} from 'actions/index.js';
import {useKeys} from './useKeys.js';
import SavePad from './SavePad.js';
import {setPadsExpand} from 'actions/index.js';
import ContextMenu from "components/dropdowns/ContextMenu.js";
import MenuItem from "components/dropdowns/MenuItem.js";
import {useContextMenu} from "components/dropdowns/useContextMenu.js";
import Documented from "components/help/Documented.js";
import {
    PADS_EXPAND_BUTTON
} from "constants/contextual-help.js";
import PadWaveform from './PadWaveform.js';
import TrackComponent from "components/v2/TrackComponent.js";
import PadToolbar from './PadToolbar.js';
import PadSlot from './PadSlot.js';
import PadVisualizer from './PadVisualizer.js';
import {WAVEFORM, DELETE, MUTES} from './modes.js';
import {connect} from 'react-redux';

const PadComponent = ({
    pad,
    scrollContainer,
    selectedTrack,
    setShowPadSequencer,
    tracks,
    setPadExpand,
    trackToShow,
    setTrackToShow,
    width,
    height,
    attributes,
    showCanvas,
    zobject,
    isPulled,
    isSelected,
}) => { 
    let ref = useRef(undefined);
    let padRef = useRef(undefined);
    let posRef = useRef(undefined);

    const onDoubleClick = useDoubleClick((e) => {
    });

    let [saving, setSaving] = useState(false);
    let [mode, setMode] = useState(undefined);

    useEffect(() => {
        let track = pad.tracks.find((x,i) => x && x.trackNumber === selectedTrack);
        if (track && trackToShow !== undefined) {
            setTrackToShow(track);
        }
    }, [trackToShow, selectedTrack, setTrackToShow, pad, tracks]);

    const toggleCollapse = useCallback(() => {
        if (trackToShow) {
            return setTrackToShow(undefined);
        }
        if (selectedTrack !== undefined) {
            let track = pad.sequencerEngine.tracks[selectedTrack];
            if (pad.tracks.some(x => x === track)) {
                setTrackToShow(track);
                return;
            }
        }
        let tracks = pad.tracks.filter(x => x);
        if (tracks.length === 0) {
            return;
        }
        setTrackToShow(tracks[0]);
    }, [selectedTrack, trackToShow, pad, setTrackToShow]);

    const clearPattern = useCallback(() => {
        pad.slotTracks.forEach(({pattern}) => pattern.clear());
        pad.sequencerEngine.updateTracks();
    }, [pad]);


    let className = "pads";
    if (mode===DELETE) {
        className += " delete-mode";
    } else if (mode === MUTES) {
        className += " mute-mode";
    }

    if (saving) {
        return (
            <SavePad hide={() => setSaving(false)} pad={pad}/>
        );
    }

    const saveWindowPosition = () => {
        posRef.current = pad.sequencerEngine.state.windows.windowPositions[pad.id];
    };

    const selectPadIfNotMoved = () => {
        if (!pad.sequencerEngine.state.windows.windowPositions[pad.id]) {
            return;
        }
        let {x,y}= pad.sequencerEngine.state.windows.windowPositions[pad.id];
        if (posRef.current && x === posRef.current.x && y === posRef.current.y) {
            // setSelectedZObject(pad);
        }
    };

    let secondaryStyle = {};
    let primaryStyle = {};

    if (attributes) {
        primaryStyle["backgroundColor"] = attributes["primary-color"];
        secondaryStyle["backgroundColor"] = attributes["secondary-color"];
    }

    secondaryStyle.width = width;
    secondaryStyle.height = height;

    secondaryStyle.borderRadius = (width / 191) * 15;
    if (attributes && attributes["border-radius"]) {
        primaryStyle.borderRadius = attributes["border-radius"]/1.2 + 'px';
    } else {
        primaryStyle.borderRadius = (width / 191) * 8;
    }

    let padInnerStyle = {
        borderRadius: (width / 191) * 8
    };

    if (showCanvas) {
        className += " show-canvas";
        secondaryStyle.borderColor = attributes["secondary-color"];
    } else {
        className += " no-canvas";
    }


    let _scale=width/191;
    let padMargin = 3*_scale;

    let slotsWidth = width - 26;
    let padsPerRow = isNaN(attributes["Pads Per Row"]) ? 3 : attributes["Pads Per Row"];
    let slotSize = (slotsWidth - 2*padsPerRow*padMargin) / padsPerRow;

    return (
        <div
          ref={padRef}
          onClick={onDoubleClick}
          style={secondaryStyle}
          onMouseDown={saveWindowPosition}
          onMouseUp={selectPadIfNotMoved}
          onDrop={(e) => e.stopPropagation()}
          className={className}>
          <div style={padInnerStyle} className="pad-inner">
           {/*<Documented
              element={PADS_EXPAND_BUTTON}
              onClick={toggleCollapse}
              className="collapse-container">
              <div
                className={trackToShow ? "arrow-right" : "arrow-down"}/>
                </Documented>*/}
            <div
              style={primaryStyle}
              className="slots-and-track">
              <div
              >
                <Documented element={GO_TO_PAD_SEQUENCER} onClick={() => {
                    setSelectedZObject(undefined);
                    setShowPadSequencer(pad);
                }} className="step-sequencer-btn">
                  <div className="pad-dot"/>
                  <div className="pad-dot"/>
                  <div className="pad-dot"/>
                </Documented>
                {showCanvas && <ZCanvas3DComponent className="pad-canvas" width={width - 13} height={height - 18} zobject={pad.canvas}/>}
            <PadToolbar
              mode={mode} setMode={setMode} pad={pad}/>
                <div style={{width: slotsWidth}} className="pad-slots">
              {pad.tracks.map(
                  (slot, slotNumber) =>
                      slot ? <PadSlot
                               attributes={attributes}
                               showCanvas={showCanvas}
                               size={slotSize}
                               scale={width/191}
                               setTrackToShow={setTrackToShow}
                               trackToShow={trackToShow}
                               key={slotNumber}
                               slotNumber={slotNumber}
                               pad={pad}
                               slot={slot}
                               mode={mode}
                             /> : <EmptySlot
                                    attributes={attributes}
                                    scale={width/191}
                                    size={slotSize} pad={pad} slotNumber={slotNumber}/>
                      )}
            </div></div>
          {trackToShow ?
           <TrackComponent
             isDraggable={false}
             onHide={() => setTrackToShow(undefined)}
             forceShow={true}
             track={trackToShow}
             scrollContainer={scrollContainer}/> : ''}
            </div>
            <div className="pad-bottom" ref={ref}>
              {mode === WAVEFORM ? <PadWaveform div={ref} pad={pad}/> :
               !isPulled && <PadVisualizer trackToShow={trackToShow} container={padRef} pad={pad}/>}
            </div>
          </div>
       </div>);
}

const mapStateToProps = (state, props) => {
  return {
      tracks: props.pad.tracks,
      selectedTrack: state.mix.selectedTrack,
      trackToShow: state.pads.padsExpand && state.pads.padsExpand.pad === props.pad ?
          state.pads.padsExpand : undefined,
      isSelected: state.windows.selectedElements[props.pad.id],
      showCanvas: props.pad.showCanvas
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setShowPadSequencer: x => dispatch(setShowPadSequencer(x)),
      setTrackToShow: x => dispatch(setPadsExpand(x)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PadComponent);
